"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMillisecondsToDate = void 0;
function addMillisecondsToDate(date, milliseconds) {
    return new Date(date.getTime() + milliseconds);
}
exports.addMillisecondsToDate = addMillisecondsToDate;
